import { createSlice } from '@reduxjs/toolkit'


const storedCartItems = localStorage.getItem('cartItems');
const MAX_CART_QTY = 5;

const parseStoredCart = () => {
  if (!storedCartItems) return [];
  try {
    const parsed = JSON.parse(storedCartItems);
    if (!Array.isArray(parsed)) return [];
    const sanitized = parsed.filter((item) => item && typeof item === 'object');
    if (sanitized.length !== parsed.length) {
      localStorage.setItem('cartItems', JSON.stringify(sanitized));
    }
    return sanitized;
  } catch (error) {
    localStorage.removeItem('cartItems');
    return [];
  }
};

const initialState = parseStoredCart();

function saveCartToLocalStorage(products) {
  localStorage.setItem('cartItems', JSON.stringify(products));
}

export const cartSlice = createSlice({
  name: 'cartSliceName',
  initialState,
  reducers: {
    addProduct: (state, { payload }) => {
      const productExist = state.findIndex(item => item.id === payload.id);
      if (productExist !== -1) {
        state[productExist].qty = Math.min(Number(state[productExist].qty || 1) + 1, MAX_CART_QTY);
        state[productExist].totalPrice = state[productExist].qty * state[productExist].price;
      } else { state.push({ ...payload, qty: Math.min(Number(payload?.qty || 1), MAX_CART_QTY) }) };
      saveCartToLocalStorage(state)
      return state 
    },
    increaseQty: (state, { payload }) => {
      const productIndex = state.findIndex(item => item.id === payload.id);
      if (productIndex !== -1) {
        const unitPrice = Number(state[productIndex].sprice ?? state[productIndex].price ?? 0);
        state[productIndex].qty = Math.min(Number(state[productIndex].qty || 1) + 1, MAX_CART_QTY);
        state[productIndex].totalPrice = unitPrice * state[productIndex].qty;
      }
      saveCartToLocalStorage(state);
      return state;
    },
    decreaseQty: (state, { payload }) => {
      const productIndex = state.findIndex(item => item.id === payload.id);
      if (productIndex !== -1) {
        const currentQty = Number(state[productIndex].qty || 1);
        const nextQty = currentQty > 1 ? currentQty - 1 : 1;
        const unitPrice = Number(state[productIndex].sprice ?? state[productIndex].price ?? 0);
        state[productIndex].qty = nextQty;
        state[productIndex].totalPrice = unitPrice * nextQty;
      }
      saveCartToLocalStorage(state);
      return state;
    },
    removeProduct: (state, { payload }) => {
      state = state.filter(item => item.id !== payload.id);
      saveCartToLocalStorage(state)
      return state
    },
    updateProduct: () => {

    },
    clearCart: () => {
      saveCartToLocalStorage([]);
      return [];
    },
    success: (state, {payload})=>{
      state = payload
      return state
    },
    failed:()=>{

    },
    placeorder:(state, {payload})=>{
      // state['loading'] = true;

    }
  },
})

// Action creators are generated for each case reducer function
export const { addProduct, increaseQty, decreaseQty, removeProduct, clearCart, updateProduct, getProduct, success, failed, getOneProduct, placeorder } = cartSlice.actions

export default cartSlice.reducer
